<!-- Preliminary step for direct allocation - only shown for new allocations -->
@if (!isUpdating && !preliminaryStepCompleted) {
  <div class="comply-card">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">Zahtjev za izravnom dodjelom sredstava</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="p-3">
        <div class="legal-content">
          <p>Sukladno članku 6., stavku 3. Uredbe o kriterijima, mjerilima i postupcima financiranja i ugovaranja
            programa i projekata od interesa za opće dobro koje provode udruge ("Narodne novine", broj 26/15 i
          37/21), financijska sredstva bez objavljivanja javnog natječaja dodjeljuju se izravno samo:</p>
          <ul>
            <li>u opravdanim i iznimnim slučajevima, kada nepredviđeni događaji obvezuju davatelja financijskih
              sredstava da u suradnji s udrugama žurno djeluje u rokovima u kojima nije moguće provesti
              standardni natječajni postupak i problem je moguće riješiti samo izravnom dodjelom financijskih
            sredstava</li>
            <li>kada se financijska sredstva dodjeljuju udruzi ili skupini udruga koje imaju isključivu nadležnost u
              području djelovanja i/ili zemljopisnog područja za koje se financijska sredstva dodjeljuju ili je udrugs
              jedina organizacija operativno sposobna za rad na području djelovanja i/ili zemljopisnom području na
            kojem se financirane aktivnosti provode</li>
            <li>kada se financijska sredstva dodjeljuju udruzi koja je na temelju propisa izrijekom navedena kao
            provoditelj određene aktivnosti</li>
            <li>kada se prema mišljenju nadležnog povjerenstva jednokratno dodjeljuju financijska sredstva do
              5.000 kuna za aktivnosti koje iz opravdanih razloga nisu mogle biti planirane u godišnjem planu
              udruge, a ukupan iznos tako dodijeljenih sredstava iznosi najviše 5% svih sredstava planiranih u
            proračunu za financiranje svih programa i projekata udruga</li>
            <li>„kada je to propisano posebnim propisom".</li>
          </ul>
        </div>
        <div class="action-container mt-4">
          <button mat-flat-button color="primary" class="daxa" (click)="completePreliminaryStep()">
            Podnesi zahtjev
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}

<!-- Main stepper - shown after preliminary step for new allocations or directly for updates -->
@if (isUpdating || preliminaryStepCompleted) {
  <mat-stepper [orientation]="isHandset ? 'vertical' : 'horizontal'" #stepper>
    <!-- Step 1: General Information -->
    <mat-step [stepControl]="generalInfoFormGroup">
      <ng-template matStepLabel>I. Opći podaci o prijavitelju</ng-template>
      @if (stepper.selectedIndex === 0) {
        <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
          <mat-card-header>
            <mat-card-title>
              <h5 class="mb-0">I. Opći podaci o prijavitelju</h5>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <form [formGroup]="generalInfoFormGroup">
              @for (field of [
                { control: 'organizationName',          label: 'Nositelj aktivnosti (naziv udruge/organizacije civilnog društva)',                                         placeholder: 'Nositelj aktivnosti',       type: 'text', config: {} },
                { control: 'registrationNumber',        label: 'Registrarski broj u odgovarajućem registru (Registar udruga, Registar zaklada i dr.-Ministarstvo uprave)', placeholder: 'Registracijski broj',       type: 'text', config: {} },
                { control: 'oib',                       label: 'OIB',                                                                                                      placeholder: 'OIB',                       type: 'text', config: {} },
                { control: 'rno',                       label: 'Broj u Registru neprofitnih organizacija (RNO broj - Ministarstvo financija)',                             placeholder: 'RNO broj',                  type: 'text', config: {} },
                { control: 'address',                   label: 'Adresa udruge/organizacije civilnog društva (ulica i broj)',                                               placeholder: 'Adresa',                    type: 'text', config: {} },
                { control: 'postalCodeAndHeadquarters', label: 'Poštanski broj i sjedište',                                                                                placeholder: 'Poštanski broj i sjedište', type: 'text', config: {} },
                { control: 'county',                    label: 'Županija',                                                                                                 placeholder: 'Županija',                  type: 'text', config: {} },
                { control: 'telephone',                 label: 'Broj telefona i telefaksa udruge/organizacije civilnog društva',                                           placeholder: 'Telefon i telefaks',        type: 'text', config: {} },
                { control: 'organizationEmail',         label: 'Adresa e-pošte udruge/organizacije civilnog društva',                                                      placeholder: 'E-mail',                    type: 'text', config: {} },
                { control: 'website',                   label: 'Internetska stranica udruge/organizacije civilnog društva',                                                placeholder: 'Web',                       type: 'text', config: {} },
                { control: 'authorizedRepresentative',  label: 'Ime i prezime osobe ovlaštene za zastupanje udruge/organizacije civilnog društva',                         placeholder: 'Zastupnik',                 type: 'text', config: {} },
                { control: 'bankName',                  label: 'Naziv banke',                                                                                              placeholder: 'Naziv banke',               type: 'text', config: {} },
                { control: 'bankAccountNumber',         label: 'IBAN',                                                                                                     placeholder: 'IBAN',                      type: 'text', config: {} }
                ]; track field) {
                <div>
                  <div class="mb-25">
                    @if (field.type === 'text') {
                      <mat-form-field class="full-width">
                        <mat-label>{{ field.label }}</mat-label>
                        <textarea matInput [formControlName]="field.control"></textarea>
                      </mat-form-field>
                    }
                    @if (field.type === 'number') {
                      <mat-form-field class="full-width">
                        <mat-label>{{ field.label }}</mat-label>
                        <input matInput formattedNumber
                          [config]="field.config"
                          [formControlName]="field.control" />
                        </mat-form-field>
                      }
                      @if (field.type === 'date') {
                        <mat-form-field class="full-width">
                          <mat-label>{{ field.label }}</mat-label>
                          <input matInput [matDatepicker]="picker" [formControlName]="field.control">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                      }
                      @if (field.type === 'checkbox') {
                        <mat-checkbox [formControlName]="field.control">{{ field.label }}</mat-checkbox>
                      }
                      @if (field.type === 'select') {
                        <mat-form-field class="full-width">
                          <mat-label>{{ field.label }}</mat-label>
                          <mat-select [formControlName]="field.control">
                            @for (item of ($any(field).dataSource || []); track item) {
                              <mat-option [value]="item.value">
                                {{ item.label }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                    </div>
                  </div>
                }
                <div>
                  <button mat-flat-button matStepperNext class="daxa" [disabled]="generalInfoFormGroup.invalid">Dalje</button>
                </div>
              </form>
            </mat-card-content>
          </mat-card>
        }
      </mat-step>
      <!-- Step 2: Program / Project Information -->
      <mat-step [stepControl]="activityInfoGroup">
        <ng-template matStepLabel>II. Podaci o aktivnosti</ng-template>
        @if (stepper.selectedIndex === 1) {
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-header>
              <mat-card-title>
                <h5 class="mb-0">II. Podaci o aktivnosti</h5>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <form [formGroup]="activityInfoGroup">
                @for (field of [
                  { label: 'Naziv aktivnosti',                                                    control: 'activityName',                                                                                                        type: 'text', config: {} },
                  { label: 'Ime i prezime voditelja aktivnosti',                                  control: 'projectLeader',                                                                                                       type: 'text', config: {} },
                  { label: 'Zatraženi iznos (u eurima - brojkom i slovima): EUR (eura)',          control: 'amountRequestedFromMunicipality',                                   type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
                  { label: 'Datum i vrijeme početka provedbe aktivnosti',                         control: 'implementationStart',               type: 'datetime', config: { dateLabel: 'Datum početka provedbe aktivnosti', timeLabel: 'Vrijeme početka provedbe aktivnosti' } },
                  { label: 'Datum i vrijeme završetka provedbe aktivnosti',                       control: 'implementationEnd',                 type: 'datetime', config: { dateLabel: 'Datum završetka provedbe aktivnosti', timeLabel: 'Vrijeme završetka provedbe aktivnosti'} },
                  { label: 'Kratki opis aktivnosti',                                              control: 'activityDescription',                                                                                                 type: 'text', config: {} },
                  { label: 'Područje djelovanja udruge/organizacije civilnog društva kojima se ostvaruju ciljevi propisani statutom organizacije', control: 'fieldOfOperation',                                                   type: 'text', config: {} },
                  { label: 'Ciljane skupine (udruge/organizacije civilnog društva mogu imati jednu ili više ciljanih skupina s obzirom na članstvo i/ili korisnike prema kojima je organizacija usmjerena)', control: 'targetGroups', type: 'text', config: {} },
                  { label: 'Teritorijalna zastupljenost',                                         control: 'territorialCoverage',                                                                                                 type: 'text', config: {} },
                  { label: 'Uključivanje volontera - sudjeluju li volonteri? (DA/NE)',            control: 'volunteersInvolved',                                                                                                 type: 'checkbox', config: {} },
                  { label: 'Broj potencijalno uključenih volontera',                              control: 'potentialVolunteerCount',                                           type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } }
                  ]; track field) {
                  <div>
                    <div class="mb-25">
                      @if (field.type === 'text') {
                        <mat-form-field class="full-width">
                          <mat-label>{{ field.label }}</mat-label>
                          <textarea matInput [formControlName]="field.control"></textarea>
                        </mat-form-field>
                      }
                      @if (field.type === 'number') {
                        <mat-form-field class="full-width">
                          <mat-label>{{ field.label }}</mat-label>
                          <input matInput formattedNumber [config]="field.config" [formControlName]="field.control" />
                        </mat-form-field>
                      }
                      @if (field.type === 'date') {
                        <mat-form-field class="full-width">
                          <mat-label>{{ field.label }}</mat-label>
                          <input matInput [matDatepicker]="picker" [formControlName]="field.control">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                      }
                      @if (field.type === 'datetime') {
                        <app-datetime class="full-width" [label]="field.label" [config]="field.config" [formControlName]="field.control">
                        </app-datetime>
                      }
                      @if (field.type === 'checkbox') {
                        <mat-checkbox [formControlName]="field.control">{{ field.label }}</mat-checkbox>
                      }
                      @if (field.type === 'select') {
                        <mat-form-field class="full-width">
                          <mat-label>{{ field.label }}</mat-label>
                          <mat-select [formControlName]="field.control">
                            @for (item of ($any(field).dataSource || []); track item) {
                              <mat-option [value]="item.value">
                                {{ item.label }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                    </div>
                  </div>
                }
                <div>
                  <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
                  <button mat-flat-button matStepperNext class="daxa" [disabled]="activityInfoGroup.invalid">Dalje</button>
                </div>
              </form>
            </mat-card-content>
          </mat-card>
        }
      </mat-step>
      <!-- Step 3: Justification Information -->
      <mat-step [stepControl]="justificationFormGroup">
        <ng-template matStepLabel>III. Obrazloženje</ng-template>
        @if (stepper.selectedIndex === 2) {
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-header>
              <mat-card-title>
                <h5 class="mb-0">III. Obrazloženje</h5>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <form [formGroup]="justificationFormGroup">
                <mat-form-field class="mb-25">
                  <mat-label>20. Obrazloženje (navedite zašto tražite izravnu dodjelu sredstava)</mat-label>
                  <textarea matInput formControlName="justification"></textarea>
                </mat-form-field>
                <div>
                  <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
                  <button mat-flat-button matStepperNext class="daxa" [disabled]="justificationFormGroup.invalid">Dalje</button>
                </div>
              </form>
            </mat-card-content>
          </mat-card>
        }
      </mat-step>
      <!-- Step 4: Budget Plan -->
      <mat-step [stepControl]="budgetPlanFormGroup">
        <ng-template matStepLabel>IV. Proračun</ng-template>
        @if (stepper.selectedIndex === 3) {
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-header>
              <mat-card-title>
                <h5 class="mb-0">IV. Proračun</h5>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              @if (!isLoading) {
                <app-budget-plan
                  [budgetPlanForm]="budgetPlanFormGroup">
                </app-budget-plan>
              }
              <div class="actions">
                <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
                <button mat-flat-button matStepperNext class="daxa" [disabled]="budgetPlanFormGroup.invalid">Dalje</button>
              </div>
            </mat-card-content>
          </mat-card>
        }
      </mat-step>
      <!-- Step 5: Documents -->
      <mat-step [stepControl]="attachmentsFormGroup">
        <ng-template matStepLabel>V. Dokumenti</ng-template>
        @if (stepper.selectedIndex === 4) {
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-header>
              <mat-card-title>
                <h5 class="mb-0">V. Dokumenti</h5>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <p class="mb-10">
                <strong>Molimo Vas priložite sljedeće dokumente:</strong>
              </p>
              <ul>
                <li><strong>1. Potvrdu nadležne Porezne uprave koja potvrđuje da korisnik nema dug (ne stariju od 30 dana od dana predaje Potvrde)</strong></li>
                <li><strong>2. Uvjerenje nadležnog suda da se protiv osobe ovlaštene za zastupanje udruge i voditelja projekta ne vodi kazneni postupak koje nije starije od šest mjeseci od dana predaje uvjerenja</strong></li>
              </ul>
              @if (!isLoading) {
                <app-file-upload
                  [storageLocation]="attachmentsFormGroup.get('fileStorageLocation')?.value">
                </app-file-upload>
              }
              <br/>
            </mat-card-content>
            <div class="actions px-2 pb-2">
              <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
              <button mat-flat-button matStepperNext class="daxa">Dalje</button>
            </div>
          </mat-card>
        }
      </mat-step>
      <!-- Step 6: Review and Submit -->
      <mat-step>
        <ng-template matStepLabel>Završetak</ng-template>
        @if (stepper.selectedIndex === 5) {
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-header>
              <mat-card-title>
                <h5 class="mb-0">Čestitamo, stigli ste do samoga završetka!
                Pritiskom na gumb, Vaš zahtjev za izravnom dodjelom sredstava bit će spremljen kao skica. Sve dok je u statusu skice, možete je slobodno uređivati i prilagođavati.</h5>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div>
                <button mat-flat-button class="mr-15" matStepperPrevious>Nazad</button>
                <button mat-flat-button color="primary" (click)="onSubmit(stepper)">Spremite</button>
              </div>
            </mat-card-content>
          </mat-card>
        }
      </mat-step>
    </mat-stepper>
  }

  <!-- Sticky Save Button - Show after preliminary step in create mode or always in edit mode -->
  @if (!isLoading && (isUpdating || preliminaryStepCompleted)) {
    <div class="sticky-save-container">
      <button
        mat-fab
        color="primary"
        class="sticky-save-button"
        (click)="saveAllocation()"
        [disabled]="isSaving"
        [matTooltip]="'Spremi promjene'">
        @if (!isSaving) {
          <mat-icon>save</mat-icon>
        }
        @if (isSaving) {
          <mat-icon class="spinning">hourglass_empty</mat-icon>
        }
      </button>
    </div>
  }
